module.exports = __webpack_public_path__ + "static/media/Chloe-Gray-Nile-Bracelet-Small-Cross-body-Bag-Lyst.d616c38a.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/products/bags/Chloe-Gray-Nile-Bracelet-Small-Cross-body-Bag-Lyst.png
// module id = 211
// module chunks = 0